var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c("img", { attrs: { src: require("../assets/1.png"), width: "100%" } }),
    _c("div", { staticClass: "menu" }, [
      _c("img", { attrs: { src: require("../assets/2.png") } }),
      _c("ul", { staticClass: "list" }, [
        _c(
          "li",
          {
            class: {
              selected: _vm.currentSelect == 1,
              yellow: _vm.currentSelect == 1
            },
            on: {
              click: function($event) {
                return _vm.SelectIndex(1)
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.pic1 } }),
            _c("p", [_vm._v("发起申请")])
          ]
        ),
        _c(
          "li",
          {
            class: {
              selected: _vm.currentSelect == 2,
              red: _vm.currentSelect == 2
            },
            on: {
              click: function($event) {
                return _vm.SelectIndex(2)
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.pic2 } }),
            _c("p", [_vm._v("我的申请")])
          ]
        ),
        _c(
          "li",
          {
            class: {
              selected: _vm.currentSelect == 3,
              blue: _vm.currentSelect == 3
            },
            on: {
              click: function($event) {
                return _vm.SelectIndex(3)
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.pic3 } }),
            _c("p", [_vm._v("待我审批")])
          ]
        ),
        _c("div", { staticClass: "clear" })
      ]),
      _c("div", { staticClass: "clear" }),
      _vm.currentSelect == 1
        ? _c("div", { staticClass: "list2" }, [
            _vm._m(0),
            _c("div", { staticClass: "clear" })
          ])
        : _vm._e(),
      _vm.currentSelect == 2
        ? _c("div", { staticClass: "list2" }, [
            _c("ul", [
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToList(1)
                      }
                    }
                  },
                  [
                    _c("img", { attrs: { src: require("@/assets/28.png") } }),
                    _c("p", [_vm._v("草稿箱")])
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToList(2)
                      }
                    }
                  },
                  [
                    _c("img", { attrs: { src: require("@/assets/16.png") } }),
                    _c("p", [_vm._v("处理中")])
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToList(6)
                      }
                    }
                  },
                  [
                    _c("img", { attrs: { src: require("@/assets/30.png") } }),
                    _c("p", [_vm._v("已通过")])
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToList(4)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { "padding-top": "0px" },
                      attrs: { src: require("@/assets/27.png") }
                    }),
                    _c("p", [_vm._v("已拒绝")])
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToList(5)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { "padding-top": "10px" },
                      attrs: { src: require("@/assets/29.png") }
                    }),
                    _c("p", [_vm._v("已作废")])
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToList(3)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { "padding-top": "10px" },
                      attrs: { src: require("@/assets/26.png") }
                    }),
                    _c("p", [_vm._v("已归档")])
                  ]
                )
              ]),
              _vm._m(1)
            ]),
            _c("div", { staticClass: "clear" })
          ])
        : _vm._e(),
      _vm.currentSelect == 3
        ? _c("div", { staticClass: "list2" }, [
            _c("ul", [
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToApproveList(1)
                      }
                    }
                  },
                  [
                    _c("img", { attrs: { src: require("@/assets/31.png") } }),
                    _c("p", [_vm._v("待处理")])
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    staticStyle: { color: "#fff" },
                    on: {
                      click: function($event) {
                        return _vm.GoToApproveList(2)
                      }
                    }
                  },
                  [
                    _c("img", { attrs: { src: require("@/assets/32.png") } }),
                    _c("p", [_vm._v("已处理")])
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "clear" })
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { display: "flex", "flex-wrap": "wrap" } }, [
      _c("li", [
        _c(
          "a",
          { staticStyle: { color: "#fff" }, attrs: { href: "/#/gsjy_create" } },
          [
            _c("img", { attrs: { src: require("@/assets/7.png") } }),
            _c("p", [
              _vm._v("工商教育"),
              _c("br"),
              _vm._v("业务线"),
              _c("br"),
              _vm._v("合同审批")
            ])
          ]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { staticStyle: { color: "#fff" }, attrs: { href: "/#/yl_create" } },
          [
            _c("img", { attrs: { src: require("@/assets/26.png") } }),
            _c("p", [_vm._v("医疗业务线"), _c("br"), _vm._v("合同审批")])
          ]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { staticStyle: { color: "#fff" }, attrs: { href: "/#/pc_create" } },
          [
            _c("img", { attrs: { src: require("@/assets/10_1.png") } }),
            _c("p", [_vm._v("餐饮业务线"), _c("br"), _vm._v("合同审批")])
          ]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { staticStyle: { color: "#fff" }, attrs: { href: "/#/zn_create" } },
          [
            _c("img", { attrs: { src: require("@/assets/8.png") } }),
            _c("p", [_vm._v("职能"), _c("br"), _vm._v("合同审批")])
          ]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { staticStyle: { color: "#fff" }, attrs: { href: "/#/gyl_create" } },
          [
            _c("img", { attrs: { src: require("@/assets/9.png") } }),
            _c("p", [_vm._v("供应链"), _c("br"), _vm._v("合同审批")])
          ]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { staticStyle: { color: "#fff" }, attrs: { href: "/#/rlwb_create" } },
          [
            _c("img", { attrs: { src: require("@/assets/10.png") } }),
            _c("p", [_vm._v("人力外包"), _c("br"), _vm._v("合同审批")])
          ]
        )
      ]),
      _c("li", [
        _c(
          "a",
          {
            staticStyle: { color: "#fff" },
            attrs: { href: "/#/stamp_create" }
          },
          [
            _c("img", { attrs: { src: require("@/assets/33.png") } }),
            _c("p", [_vm._v("非协议类"), _c("br"), _vm._v("用章申请")])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          staticStyle: { color: "#fff" },
          attrs: { href: "/#/stamp_EntrustConfig" }
        },
        [
          _c("img", {
            staticStyle: { "padding-top": "10px" },
            attrs: { src: require("@/assets/34.png") }
          }),
          _c("p", [_vm._v("用章"), _c("br"), _vm._v("委托人设置")])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }